'use client';

import { c as _c } from "react/compiler-runtime";
import CookiePopup from '@components/cookie-popup/CookiePopup';
import Footer from '@components/footer/Footer';
import Header from '@components/header/Header';
import MenuMobile from '@components/menu-mobile/MenuMobile';
import ModalMenu from '@components/modal-menu/ModalMenu';
import { useGSAP } from '@gsap/react';
import { handleScrollY } from '@lib/store/slices/ComponentsSlice';
import { ScrollSmoother, ScrollTrigger } from '@lib/tools/gsap-init';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
if (typeof window !== 'undefined') {
  window.history.scrollRestoration = 'manual';
}
function BaseLayout(t0) {
  const $ = _c(25);
  const {
    isANewUser,
    menuMobile,
    children,
    commonModals,
    renderFooter,
    isMobile,
    deviceType
  } = t0;
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();
  const pathname = usePathname();
  let t1;
  if ($[0] !== dispatch) {
    t1 = () => {
      ScrollTrigger.clearScrollMemory?.();
      let lastScroll = 0;
      const smoother = ScrollSmoother.create({
        wrapper: wrapperRef.current,
        content: wrapperRef.current.querySelector("#smooth-content"),
        smooth: 1.2,
        effects: true,
        smoothTouch: 0.1
      });
      const scrollST = ScrollTrigger.create({
        start: 0,
        end: "max",
        onUpdate: () => {
          const currentScroll = smoother.scrollTop();
          if (currentScroll !== lastScroll) {
            lastScroll = currentScroll;
            dispatch(handleScrollY(currentScroll));
          }
        }
      });
      ScrollTrigger.refresh(true);
      return () => {
        scrollST.kill();
        smoother.kill();
      };
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      scope: wrapperRef
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useGSAP(t1, t2);
  let t3;
  if ($[3] !== pathname) {
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(_temp2, t3);
  let t4;
  if ($[5] !== deviceType || $[6] !== isMobile) {
    t4 = <Header isMobile={isMobile} deviceType={deviceType} />;
    $[5] = deviceType;
    $[6] = isMobile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== isANewUser) {
    t5 = !isANewUser && <CookiePopup />;
    $[8] = isANewUser;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== isMobile || $[11] !== renderFooter) {
    t6 = renderFooter && <Footer isMobile={isMobile} />;
    $[10] = isMobile;
    $[11] = renderFooter;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children || $[14] !== t5 || $[15] !== t6) {
    t7 = <div id="smooth-wrapper" ref={wrapperRef}><div id="smooth-content" className="App">{t5}{children}{t6}</div></div>;
    $[13] = children;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== menuMobile) {
    t8 = menuMobile && <MenuMobile />;
    $[17] = menuMobile;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ModalMenu />;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== commonModals || $[21] !== t4 || $[22] !== t7 || $[23] !== t8) {
    t10 = <>{t4}{t7}{t8}{commonModals}{t9}</>;
    $[20] = commonModals;
    $[21] = t4;
    $[22] = t7;
    $[23] = t8;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp2() {
  const refresh = _temp;
  refresh();
  const timeoutId = setTimeout(refresh, 100);
  return () => clearTimeout(timeoutId);
}
function _temp() {
  return ScrollTrigger.refresh(true);
}
export default BaseLayout;